import React, { Component } from 'react';
import styled from 'styled-components';

export default class LabelledTextInput extends Component {
  constructor(props) {
    super(props);

    this.focus = this.focus.bind(this);
  }

  focus() {
    this.refs.input.focus();
  }

  render() {
    const display = !!this.props.value ? 'block' : 'none';
    const marginTop = !!this.props.value ? '20px' : '10px';
    const { Map } = this.props;

    const { REACT_APP_GOOGLE_API_KEY } = process.env;

    return (
      <Container onClick={() => this.focus()}>
        <label htmlFor={this.props.name} style={{ display }}>{this.props.placeHolder}</label>
        <input
          ref="input"
          type={this.props.type}
          name={this.props.name}
          value={this.props.value}
          placeholder={this.props.placeHolder}
          style={Object.assign(this.props.style || {}, { marginTop })}
          onChange={this.props.onChange}
          disabled
        />
        <label style={{ marginTop: '60px', fontSize: '12px', color: '#505d68' }}>Please refine the location by dragging the pin:</label>
        <Map
          googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3&libraries=places&key=${REACT_APP_GOOGLE_API_KEY}`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `400px`, marginTop: '80px', marginBottom: '5px' }} />}
          mapElement={<div style={{ height: `100%` }} />}
          lat={this.props.lat}
          lng={this.props.lng}
          onLatLngChange={this.props.onLatLngChange}
        />
      </Container>
    );
  }
}

  // height: 70px;
const Container = styled.div`
  border: 2px solid #e5e5e5;
  border-radius: 0.25em;
  padding: 0.7em 1em;

  input {
    width: 800px;
    position: absolute;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-family: 'Karla', sans-serif;
    z-index: 1;

    &::placeholder {
      opacity: 1;
      color: #a1aeb7;
    }
    &:focus {
      outline: none;
    }
  }

  label {
    position: absolute;
    color: #a1aeb7;
    font-size: 15px;
    margin-top: 2px;
    font-family: 'Karla', sans-serif;
  }
`;



// WEBPACK FOOTER //
// ./client/redesign/web/components/LabelledTextInputWithMap/index.js